<template>
  <v-container>
    <v-row>
      <v-col>
        <h1 class="text-left">{{ $t('becomeACreator.accountSetup') }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-sheet style="
        background: #FAFAFA;
border: 2px solid #ADADAD;
box-sizing: border-box;
border-radius: 20px;
        ">
          <v-container class="pa-6">
          <StepHeader leftAlignedTitle>
            {{ title }}
          </StepHeader>
          <v-container style="max-width: 700px">
          <router-view></router-view>
          </v-container>
          <v-row justify="center">
            <v-col>
              <v-icon v-for="index in [1,2,3,4]" :key="index" :color="index == step ? 'primary' : 'secondaryBackground'">mdi-circle-medium</v-icon>
            </v-col>
          </v-row>
          </v-container>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import StepHeader from "@/components/Reusable/StepHeader";
export default {
  name: 'BecomeACreatorContainer',
  components: {
    StepHeader,
  },
  computed: {
    title() {
      return this.$route.meta.header;
    },
    step() {
      return this.$route.meta.step
    },
  },
}
</script>